<div class="card-info flex fd-col jc-c ai-c t-center mapfre-fs-xs ">
    <img class="mapfre-mb-s" src="assets/icons/info.svg" alt="">
    {{message}}
</div>